const ModulePagination = ({
    currentPage,
    totalPages,
    totalModules,
    pageSize,
    onPageChange,
    onPageSizeChange
}) => {
    if (totalPages <= 1) return null;

    const pages = [];
    const maxVisible = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);

    if (endPage - startPage < maxVisible - 1) {
        startPage = Math.max(1, endPage - maxVisible + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
    }

    return (
        <div className="modules-pagination df jcsb aic mt2rem">
            <div className="df aic">
                <span className="fs0-85rem c15 mr1rem">Rows per page:</span>
                <select
                    value={pageSize}
                    onChange={onPageSizeChange}
                    className="modules-page-select br5px p0-5rem bss bw1px"
                >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                </select>
                <span className="fs0-85rem c15 ml1rem">
                    {(currentPage - 1) * pageSize + 1}-{Math.min(currentPage * pageSize, totalModules)} of {totalModules}
                </span>
            </div>
            <div className="df aic">
                <button
                    onClick={() => onPageChange(1)}
                    disabled={currentPage === 1}
                    className="modules-page-btn"
                >
                    <i className="fa fa-angle-double-left" />
                </button>
                <button
                    onClick={() => onPageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="modules-page-btn"
                >
                    <i className="fa fa-angle-left" />
                </button>
                {pages.map(page => (
                    <button
                        key={page}
                        onClick={() => onPageChange(page)}
                        className={`modules-page-btn ${currentPage === page ? 'modules-page-active' : ''}`}
                    >
                        {page}
                    </button>
                ))}
                <button
                    onClick={() => onPageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="modules-page-btn"
                >
                    <i className="fa fa-angle-right" />
                </button>
                <button
                    onClick={() => onPageChange(totalPages)}
                    disabled={currentPage === totalPages}
                    className="modules-page-btn"
                >
                    <i className="fa fa-angle-double-right" />
                </button>
            </div>
        </div>
    );
};

export default ModulePagination;

